import { render } from "./dropdown_department.vue?vue&type=template&id=462b1874"
import script from "./dropdown_department.vue?vue&type=script&lang=js"
export * from "./dropdown_department.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__